import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { patientListInitialData, patientListData, tag } from '../mockData/patient-list-data';

const PatientsListApi = [
  rest.get(`${API_ROOT}patients-list/initial`, (req, res, ctx) => res(ctx.json(patientListInitialData))),
  rest.post(`${API_ROOT}patients-list`, (req, res, ctx) => res(ctx.json(patientListInitialData))),
  rest.get(`${API_ROOT}patients-tags`, (req, res, ctx) =>
    res(
      ctx.json({
        patientTags: [{ title: 'tag1', value: 1 }],
        organizationTags: [{ title: 'Org Tag', value: 5, organizationId: 8 }],
      }),
    ),
  ),
  rest.post(`${API_ROOT}patients-tags`, (req, res, ctx) => res(ctx.json(tag))),
  rest.delete(`${API_ROOT}patients-tags/1`, (req, res, ctx) => {
    const patientId = req.url.searchParams.get('patientId');
    if (patientId === '200') {
      return res(ctx.json({ success: true }));
    }
    return res(ctx.json({}));
  }),
  rest.delete(`${API_ROOT}patients-tags/5`, (req, res, ctx) => {
    const patientId = req.url.searchParams.get('patientId');
    if (patientId === '200') {
      return res(ctx.json({ success: true }));
    }
    return res(ctx.json({}));
  }),

  rest.get(`${API_ROOT}patients-list`, (req, res, ctx) => {
    const page = req.url.searchParams.get('page');
    const perPage = req.url.searchParams.get('perPage');
    const filters = req.url.searchParams.get('filters');
    if (page && perPage && filters) {
      return res(ctx.json(patientListData));
    }
    return res(ctx.json({ data: [] }));
  }),
];
export default PatientsListApi;
